import moment from 'moment'
import {
  MAO_ACCEPT,
  MAX_OFFER_ATTEMPTS,
  ABOVE_THRESHOLD_BELOW_RESERVE_STATUS,
} from '../constants'

function requireUserOffer(target, name, descriptor) {
  const original = descriptor.get

  descriptor.get = function (...args) {
    return this.userActiveOffer ? original.call(this, ...args) : null
  }

  return descriptor
}

function requireActiveOffer(target, name, descriptor) {
  const original = descriptor.get

  descriptor.get = function (...args) {
    return this.activeOffer ? original.call(this, ...args) : null
  }

  return descriptor
}

// This model is for MAO ('Make an Offer') specifically
export default class OfferDetails {
  constructor(user, offerDetails) {
    this.user = user
    this.offerDetails = offerDetails
  }

  get userActiveOffer() {
    return this.offerDetails.user_active_offer_attempt
  }

  get activeOffer() {
    return this.offerDetails.latest_active_offer_attempt
  }

  get hasUserSubmittedOffer() {
    return !!this.userActiveOffer
  }

  /**
   * If the user has not logged in, we want to enable the CTA but if
   * the user is logged in and not confirmed, we want to disbale it
   */
  get canShowMaoCta() {
    return (
      (this.user.account_confirm && this.userCanSubmitOffer) ||
      !this.user.logged_in
    )
  }

  @requireUserOffer
  get latestUserOfferDate() {
    return moment(this.userActiveOffer.submitted_on).format('MMM DD, YYYY')
  }

  get totalOfferCount() {
    return this.offerDetails.total_offer_attempts_received
  }

  get offerRejected() {
    return this.hasUserSubmittedOffer
      ? this.userActiveOffer.status !== MAO_ACCEPT
      : false
  }

  @requireUserOffer
  get userHasAnAcceptedAttempt() {
    return this.userActiveOffer.status === MAO_ACCEPT
  }

  get attemptsRemaining() {
    return this.hasUserSubmittedOffer
      ? MAX_OFFER_ATTEMPTS - this.userActiveOffer.attempt_number
      : MAX_OFFER_ATTEMPTS
  }

  get userHasAttemptsRemaining() {
    return !this.hasUserSubmittedOffer || this.attemptsRemaining > 0
  }

  get userOutOfAttempts() {
    return !this.userHasAttemptsRemaining && !this.userHasAnAcceptedAttempt
  }

  get userCanSubmitOffer() {
    return (
      !this.userHasAnAcceptedAttempt &&
      (this.userHasAttemptsRemaining ||
        this.hasLastAttemptAboveThreshold ||
        this.aboveThresholdBelowReserve)
    )
  }

  get hasLastAttemptAboveThreshold() {
    return (
      this.attemptsRemaining === 1 &&
      this.offerRejected &&
      !this.aboveThresholdBelowReserve
    )
  }

  @requireUserOffer
  @requireActiveOffer
  get userHasActiveOffer() {
    return this.userActiveOffer.attempt_id === this.activeOffer.attempt_id
  }

  get latestAmount() {
    return this.hasUserSubmittedOffer ? this.userActiveOffer.attempt_amount : ''
  }

  @requireUserOffer
  get aboveThresholdBelowReserve() {
    return (
      this.userActiveOffer.status_reason ===
        ABOVE_THRESHOLD_BELOW_RESERVE_STATUS && !this.userHasAnAcceptedAttempt
    )
  }

  get hasOffers() {
    return this.totalOfferCount > 0
  }
}
